export const chainFunctions = <T>(...functions: Array<() => T | Promise<T>>) =>
  functions.reduce((promise, func) => promise.then(() => func()), Promise.resolve() as Promise<T>)
